var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box",staticClass:"waterFall-box"},[_vm._l((_vm.images),function(item,index){return _c('div',{key:index,ref:"img",refInFor:true,staticClass:"img-box"},[_c('img',{attrs:{"src":item.img,"alt":""}})])}),_vm._v(" "),(_vm.isLoad == false)?_c('footer',{style:({
      position: 'absolute',
      top: Math.max.apply(Math, _vm.heightArray) + 'px',
      color: 'red',
      left: '50%',
      transform: 'translateX(-50%)',
    })},[_vm._v("\n    没有图片加载了...\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cfb17e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/center/img.vue
// module id = null
// module chunks = 